import { createSelector } from 'reselect'
import { IModalStateRecord } from './interface'

export const baseState = (state: any): IModalStateRecord => state.get('modal')

export const isOpen = createSelector(baseState, state => state.get('isOpen'))

export const closeTimeoutMS = createSelector(baseState, state => state.get('closeTimeoutMS'))

export const contentLabel = createSelector(baseState, state => state.get('contentLabel'))

export const children = createSelector(baseState, state => state.get('children'))

export const restProps = createSelector(baseState, state => state.get('restProps'))
